import { render, staticRenderFns } from "./_Campaign.vue?vue&type=template&id=5854e61a&"
import script from "./_Campaign.vue?vue&type=script&lang=js&"
export * from "./_Campaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports